import React, { memo } from 'react';
import { getTableRowModeBoolean } from 'shared/Table/Actions/utilities';
import { useTableActiveRowContext } from 'shared/Table/TableActiveRowContext';
import { IActiveNumbersItem } from '@EngagementsActiveNumbers/activeNumbers.model';
import CancelOrderModalForm from 'pages/WirelineEngagements/shared/CancelOrderModalForm';
import { cancelOrderDiscoTitle } from 'pages/WirelineEngagements/shared/CancelOrderModalForm/constants';

const CancelOrderModal = () => {
  const {
    activeRow,
    activeRowMode,
    cleanActiveRow,
  } = useTableActiveRowContext<IActiveNumbersItem>();

  const { isCancelOrderMode } = getTableRowModeBoolean(activeRowMode);

  return (
    <CancelOrderModalForm
      activeRow={activeRow}
      isOpen={isCancelOrderMode}
      title={cancelOrderDiscoTitle}
      cleanActiveRow={cleanActiveRow}
    />
  );
};

export default memo(CancelOrderModal);
